import { render, staticRenderFns } from "./ActsAndRules.vue?vue&type=template&id=8d6d2674&"
import script from "./ActsAndRules.vue?vue&type=script&lang=js&"
export * from "./ActsAndRules.vue?vue&type=script&lang=js&"
import style0 from "./ActsAndRules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports